<ngx-button
  [fullWidth]="fullWidth()"
  [mode]="mode()"
  [size]="size()"
  [style]="style()"
  [brandButton]="brandButton()"
  [destructive]="destructive()"
  [rightIcon]="rightIcon()"
  [leftIcon]="leftIcon()"
  [disabled]="disabled()"
  [isLoading]="isLoading()"
  [classNames]="classNames()"
  (clickHandler)="onClick($event)"
>
  <ng-content></ng-content>
</ngx-button>
